import React from 'react'
import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import { X } from 'react-bootstrap-icons'
import useViewport from '../../../hooks/use-viewport'
import Header from './header'

const CommonModal = ({
    onHide = () => {},
    children,
    full,
    backdrop,
    closeButton,
    size,
    fullWidth,
    fullHeight,
    closeStyle = {},
}) => {
    const { height } = useViewport()
    const modalHeight = Math.floor(height * 0.9)

    const renderCloseButton = () => {
        if (!closeButton) {
            return null
        }

        return (
            <div style={{ color: 'rgb(0, 123, 255)', cursor: 'pointer', ...closeStyle }} onClick={() => onHide()}>
                <X size={30} />
            </div>
        )
    }

    return createPortal(
        <Modal
            size={size}
            show
            dialogClassName={`${full || fullWidth ? 'modal-90w' : '' }`}
            backdrop={backdrop}
            onHide={onHide}
        >
            <Modal.Body style={{ padding: '0px' }}>
                <div
                    style={{
                        ...closeStyle,
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        zIndex: '100',
                        
                    }}
                >
                    {renderCloseButton()}
                </div>
                <div
                    style={{
                        minHeight: full || fullHeight ? `${modalHeight}px` : undefined,
                        height: full || fullHeight ? `${modalHeight}px` : undefined,
                        overflowY: full || fullHeight ? 'auto' : undefined,
                    }}
                >
                    {children}
                </div>
            </Modal.Body>
        </Modal>
        , document.body)
}

CommonModal.Header = Header

export default CommonModal